/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferServicesSummaryResponse } from '../../models/offer-services-summary-response';

export interface GetAllOfferServices$Params {
  id: number;
}

export function getAllOfferServices(http: HttpClient, rootUrl: string, params: GetAllOfferServices$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferServicesSummaryResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllOfferServices.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferServicesSummaryResponse>;
    })
  );
}

getAllOfferServices.PATH = '/offers/{id}/services/all';
